export class ActivityLogApi {
  static getActivityLogApiUrl: string = '/api/ActivityLog/GetActivityLogList';
}

export class RiskIntegratorApi{
  static getParentRiskIntegrator:string='/api/RiskIntegrators/GetRiskIntegratorMasterDropDownData'
  static createParentRiskIntegrator:string='/api/RiskIntegrators/GetRiskIntegratorById'
  static markAsCompletedParentRiskIntegrator:string='/api/RiskIntegrators/markAsCompletedParentRiskIntegrator'
  static undoParentRiskIntegrator:string='/api/RiskIntegrators/undoParentRiskIntegrator'
  static addEditRiskIntegrator:string='/api/RiskIntegrators/addEditRiskIntegrator'
  static initCreateRiskIntegratorApiUrl: string = '/api/RiskIntegrators/InitCreateRiskIntegrator';
  static createRiskIntegratortApiUrl: string = '/api/RiskIntegrators/CreateRiskIntegrator';
  static getEntitySettingApiUrl: string = '/api/RiskIntegrators/GetEntitySettings';
  static getRiskIntegratorListApiUrl:string ='/api/RiskIntegrators/GetAssessmentListAsync';
  static DeleteRiskIntegratorApiUrl:string ='/api/RiskIntegrators/DeleteRiskIntegrator';
  static GetRiskIntegratorsById:string ='/api/RiskIntegrators/GetRiskIntegratorsById';
  static updateRiskIntegratorApiUrl:string ='/api/RiskIntegrators/UpdateRiskIntegrator';
  static markAsCompletredApiUrl:string ='/api/RiskIntegrators/MarkRiskIntegratorAsCompleted';
  static getRiskIntegratorQuestionApiUrl:string ='/api/RiskIntegrators/GetRiskIntegratorQuestion';
  static getRiskIntegratorReviewQuestionApiUrl:string ='/api/RiskIntegrators/GetRiskIntegratorReviewQuestion';
  static getRiskIntegratorProcessApiUrl:string ='/api/RiskIntegrators/getRiskIntegratorProcess';
  static getCompletedPolicyriskIntegratorApiUrl: string = '/api/RiskIntegrators/GetCompletedPolicy';
  static getCriticalPolicyCountByRiskIntegratorApiUrl: string = '/api/RiskIntegrators/getCriticalPolicyCountByRiskIntegrator';
  static reviewRiskIntegratorBulkApiUrlApiUrl: string = '/api/RiskIntegrators/reviewRiskIntegratorBulk';
  static getpolicyListApiUrl: string = '/api/RiskIntegrators/GetCompanyPolicySelection';
  static getQuestionsByPolicyIdApiUrl: string = '/api/RiskIntegrators/GetQuestionsByPolicyId';
  static addeditQuestionsApiUrl: string = '/api/RiskIntegrators/addeditQuestions';
  static deleteQuestionsApiUrl: string = '/api/RiskIntegrators/deleteQuestions';
  static retoreQuestionsApiUrl: string = '/api/RiskIntegrators/RetoreQuestions';
  static redirectQuestionsApiUrl: string = '/api/RiskIntegrators/RedirectQuestions';
  static getRiskFillUpquestionByIdApiUrl: string = '/api/RiskIntegrators/GetRiskFillUpquestionById';
  static answerRiskRedirectedQuestionApiUrl: string = '/api/RiskIntegrators/answerRiskRedirectedQuestion';
}

/**Assessment Api Url**/
export class AssessmentApi {
  static createAssessmentApiUrl: string = '/api/Assessment/CreateAssessment';
  static getAssessmentByIdApiUrl: string = '/api/Assessment/GetAssessmentById';
  static initCreateAssessmentApiUrl: string = '/api/Assessment/InitCreateAssessment';
  static getAssessmentListApiUrl: string = '/api/Assessment/GetAssessmentListAsync';
  static getCompanyUserByDepartment: string = '/api/Assessment/GetCompanyUserByDepartment';
  static getAssessmentMasterDropDownDataApiUrl: string = '/api/Assessment/GetAssessmentMasterDropDownData';
  static getParentAssessmentMasterDropDownDataApiUrl: string = '/api/Assessment/GetParentAssessmentMasterDropDownData';
  static getParentAssesmentDropDownData: string = '/api/Assessment/GetParentAssesmentDropDownData';
  static updateAssessmenApiUrl: string = '/api/Assessment/UpdateAssessment';
  static getAssessmentQuestionApiUrl: string = '/api/Assessment/GetAssessmentQuestion';
  static getCompanyUserByCompanyIdApiUrl: string = '/api/Assessment/GetCompanyUserByCompanyId';
  static redirectQuestionApiUrl: string = '/api/Assessment/AssessmentRedirectQuestion';
  static getCriticalPolicyCountByAssessmentApiUrl: string = '/api/Assessment/GetCriticalPoliciesCountByAssessment';
  static getPolicyRecommendationApiUrl: string = '/api/Assessment/GetPolicyRecommendation';
  static writeRecommendationApiUrl: string = '/api/Assessment/WritePolicyRecommendation';
  static getPolicyRecommendationByIdUrl: string = '/api/Assessment/GetPolicyRecommendationById'; 
  static addDepartmentApiUrl: string = '/api/Assessment/AddDepartment';
  static undoParentAssessmentApiUrl: string = '/api/Assessment/UndoParentAssessmentApiUrl';
  static getCompletedPolicyApiUrl: string = '/api/Assessment/GetCompletedPolicy';
  static getReviewQuestionApiUrl: string = '/api/Assessment/GetQuestionToReview';
  static getRedirectedQuestionListApiUrl: string = '/api/Assessment/GetRedirectedQuestionList';
  static getFillUpquestionByIdApiUrl: string = '/api/Assessment/GetFillUpQuestionById';
  static answerRedirectedQuestionApiUrl: string = '/api/Assessment/AnswerRedirectedQuestion';
  static deleteAssessmentApiUrl: string = '/api/Assessment/DeleteAssessment';
  static copyAssessmentByIdApiUrl: string = '/api/Assessment/CopyAssessmentById';
  static reviewAssessmentBulkApiUrl: string = '/api/Assessment/ReviewAssessmentBulkCopy';
  static initCopyAssessmentApiUrl: string = '/api/Assessment/InitCopyAssessment';
  static markAsCompletedApiUrl: string = '/api/Assessment/MarkAssessmentAsCompleted';
  static markAsCompletedParentAssessmentApiUrl: string = '/api/Assessment/MarkParentAssessmentAsCompleted';
  static addEditParentAssessmentApiUrl: string = '/api/Assessment/AddEditParentAssessment';
  static getParentAssessmentByIdApiUrl: string = '/api/Assessment/GetParentAssessmentById';


  static getAssessmentrProgressReportApiUrl: string = '/api/Assessment/GetAssessmentProgressReport';
  static getCompanySelectionPolicy = '/api/Assessment/GetCompanyPolicySelection';
  static getCategory = '/api/Assessment/GetCategory';
  static getCompanySelectionPolicyQuestion = '/api/Assessment/GetCompanyPolicySelectionQuestion';
  static setPolicySelectionStatus = '/api/Assessment/SetPolicySelectionStatus';
  static generateExportReport = '/api/Assessment/GeneratePolicySelectionReport';
  static setStatusOfPolicy = '/api/Assessment/SetStatusOfPolicy';
  static getDownloadFile: string = '/api/Assessment/GetDownloadFile';
  static getPolicyOfPolicySelection = '/api/Assessment/GetPolicyOfPolicySelection';
  static policySelectionEdit = '/api/Assessment/PolicySelectionEdit';
  static getpolicySelectionQuestion = '/api/Assessment/GetpolicySelectionQuestion';
  static addOrEditQuestionInPolicySelection = '/api/Assessment/AddOrEditQuestionInPolicySelection';
  static deletePolicyQuestion = '/api/Assessment/DeletePolicyQuestion';
  static getQuestionSetFromPolicyId = '/api/Assessment/GetQuestionSetFromPolicyId';
  static getLastQuestionAndSubQuestionNo = '/api/Assessment/GetLastQuestionAndSubQuestionNo';
  static getPolicySelectionConfiguration = '/api/Assessment/GetPolicySelectionConfiguration';
  static setPolicySelectionConfiguration = '/api/Assessment/SetPolicySelectionConfiguration';
  static getComplianceList = '/api/Assessment/getComplianceList';
  static getQuestionCategoryList = '/api/Assessment/getQuestionCategoryList';
  static getControlList = '/api/Assessment/getControlList';
  static getControlListFromControl = '/api/Assessment/getControlListFromControl';
  static getCategoryFromControl = '/api/Assessment/GetCategoryFromControl';
  static getControlListFromCategory = '/api/Assessment/GetControlListFromCategory';
  static getControlListFromRemoveControl = '/api/Assessment/GetControlListFromRemoveControl';
  static getMainCategoryFromAnyCategory = '/api/Assessment/getMainCategoryFromAnyCategory';
  static setControlListOfCompliance = '/api/Assessment/setControlListOfCompliance';
  static setCategoryForPolicySelection = '/api/Assessment/SetCategoryForPolicySelection';
  static getChildOrParentCategory = '/api/Assessment/GetChildOrParentCategory';
  static getControlListFromCategoryForAssessment = '/api/Assessment/GetControlListFromCategoryForAssessment';
  static getCategoryFromControlForAssessment = '/api/Assessment/GetCategoryFromControlForAssessment';
  static checkComplianaceControlAll = '/api/Assessment/CheckComplianaceControlAll';
  static getCategoryFromOneCompliance = '/api/Assessment/GetCategoryFromOneCompliance';
  static getSelectedEntityByCompany = '/api/Assessment/GetSelectedEntityByCompany';
  static getEntitiesByCompany = '/api/Assessment/GetEntitiesByCompany';
  static addEntity = '/api/Assessment/AddEntity';
  static editEntity = '/api/Assessment/EditEntity';
  static setEntityToCompany = '/api/Assessment/SetEntityToCompany';
  static setSetting = '/api/Assessment/SetSetting';
  static getCompanyName = '/api/Assessment/GetCompanyName';
  static getCompanyPolicyDocumentOfCompanyList = '/api/Assessment/GetCompanyPolicyDocumentOfCompanyList';
  static getProcedureDocumentOfCompanyList = '/api/Assessment/GetProcedureDocumentOfCompanyList';
  static changeCompanyPolicy = '/api/Assessment/ChangeCompanyPolicyDocument';
  static changeProcedure = '/api/Assessment/ChangeProcedureDocument';
  static getEntitySettingApiUrl: string = '/api/Assessment/GetEntitySettings';
  static getSubTitleOfCategoryFromCompanyQuestionCategory = '/api/Assessment/GetSubTitleOfCategoryFromCompanyQuestionCategory';
}

/** Authentication Api Url **/
export class AuthenticationApi {
  static systemAdminlogin: string = '/api/Account/Login';
  static clientLogin: string = '/api/Account/ClientLogin';
  static clientVerifyTwoFactorCode: string = '/api/Account/VerifyTwoFactorLogin';
  static logOut: string = '/api/Account/Logout';
  static verifyToken: string = '/api/Account/VerifyToken';
  static setPassword: string = '/api/Account/SetPassword';
  static resetPassword: string = '/api/Account/ResetPassword';
  static confirmMail: string = '/api/Account/ConfirmEmail';
  static confirmRecoverSecurityCodeApiUrl: string = '/api/Account/ConfirmRecoverSecurityCode';
  static doRecoverSecurityCodeApiUrl: string = '/api/Account/ChangeOrRecoverSecurityCode';
  static forgotPasswordApiUrl: string = '/api/Account/ForgotPassword';
  static recoverSecurityCodeApiUrl: string = '/api/Account/RecoverSecurityCode';
  static resendActivationLinkApiUrl: string = '/api/Account/ResendActivationLink';
  static acceptTermsPolicyApiUrl: string = '/api/Account/AcceptTermsAndPrivacy';
  static reconfirmMail: string = '/api/Account/ResendActivationMailLink';
}

/** Bs Expert Api Url **/
export class BsExpertApi {
  static bsExpertList: string = '/api/User/BsUserList';
  static roleList: string = '/api/Account/RoleList';
  static updateUserStatus: string = '/api/Account/UpdateUserStatus';
  static addUser: string = '/api/User/AddBsExpertAsync';
  static editUser: string = '/api/User/EditBsExpert';
  static skillList: string = '/api/User/GetSkillList';
  static getBsUserByEmail: string = '/api/User/GetBsUserByEmail';
  static getBsRoleListApiUrl: string = '/api/User/GetBsRoleListData';
  static getBsExpertMasterDataApiUrl: string = '/api/User/GetBsExpertMasterData';
  static initAssignCompanytoBsUser: string = '/api/User/InitAssignCompanyToBsUser';
}

export class ClientDocumentFileApi {
  static apiPrefix: string = '/api/ClientDocumentFile/';
  static getClientDocumentFileListApiUrl = ClientDocumentFileApi.apiPrefix + 'GetClientDocumentFileList';
  static getDocumentTypeListApiUrl = ClientDocumentFileApi.apiPrefix + 'GetDocumentTypeList';
  static addClientDocumentApiUrl = ClientDocumentFileApi.apiPrefix + 'AddClientDocumentFile';
  static downloadClientDocumentApiUrl = ClientDocumentFileApi.apiPrefix + 'DownloadClientDocument';
  static deleteClientDocumentApiUrl = ClientDocumentFileApi.apiPrefix + 'DeleteClientDocument';
  static getDropdownList = ClientDocumentFileApi.apiPrefix +'GetDropdownList';
}

/**Company Api List**/
export class CompanyApi {
  static getDropDownData: string = '/api/Company/GetMasterData';
  static signUp: string = '/api/Company/CompanySignUp';

  static companyUserList: string = '/api/Company/CompanyUserList';
  static companyRoleList: string = '/api/Company/RoleList';
  static companyList: string = '/api/Company/CompanyList';
  static updateCompanyStatus: string = '/api/Company/UpdateCompanyStatus';
  static getCompanyDropDown: string = '/api/Company/GetCompanyDropDown';
  static addCompany: string = '/api/Company/AddCompany';
  static editCompany: string = '/api/Company/EditCompany';
  static getCompanyById: string = '/api/Company/GetCompanyById';
  static approveCompanyApiUrl: string = '/api/Company/ApproveCompany';

  // ---- Comapny User Add Edit ----//
  static addCompanyUserApiUrl: string = '/api/Company/AddCompanyUserAsync';
  static editCompanyUserApiUrl: string = '/api/Company/EditCompanyUserProfile';
  static departmentDropDownApiUrl: string = '/api/Company/GetDepartmentDropDown';
  static getCompanyUserAddDropDownDataApiUrl: string = '/api/Company/GetCompanyUserAddDropDownData';
  static getPolicyCount: string = '/api/Company/GetPolicyCount';
  static getCheckAssessment: string = '/api/Company/CheckAssessmentStatus';

  // -- Drop Down And Check boxes lists for adding a company permission
  static getCompanyPermissionMasterDataApiUrl: string = '/api/Company/GetCompanyPermissionMasterData';

  static addEditCompanyPermissionApiUrl: string = '/api/Company/AddEditCompanyPermission';
  static getCompanyUserByEmail: string = '/api/Company/GetCompanyUserByEmail';
  static getBsUsersByCompanyIdApiUrl: string = '/api/Company/GetBsUsersByCompanyId';

  static deleteCompanyUserApiUrl: string = '/api/Company/DeleteCompanyUser';
  static deleteCompanyApiUrl: string = '/api/Company/DeleteCompany';

  static getSubscriptionServiceByCompanyIdApiUrl: string = '/api/Company/GetSubscriptionsAndServicesByCompanyId';

  static twoFactorApiUrl: string = '/api/Company/UpdateTwoFactor';

  static getCountryListApiUrl = '/api/MasterManagement/GetCountryDropdown';
  static getStateListApiUrl = '/api/MasterManagement/GetStateDropdown';
  static getGlobalSelectedApiUrl = '/api/MasterManagement/GetGlobalSelectedIds';
  static addGlobalSelectedApiUrl = '/api/MasterManagement/AddEditGlobalSelectedId';
  static getTotalActiveCompanyPolicyApiUrl = '/api/Company/GetTotalActiveCompanyPolicy';
  static inactiveAllCompanyPolicyApiUrl: string = '/api/Company/InactiveAllCompanyPolicy';
  static initAssignCompanytoUser: string = '/api/Company/InitAssignCompanyToUser';
  static updateAssignedCompanyToUserApiUrl: string = '/api/Company/UpdateAssignedCompanyToUser';
  static recoverCompany: string = '/api/Company/RecoverCompany';
}

export class ComplianceApi {
  static complianceList: string = '/api/MasterManagement/ComplianceList';
  static addOrEditCompliance: string = '/api/MasterManagement/AddEditCompliance';
  static deleteCompliance: string = '/api/MasterManagement/DeleteCompliance';
  static updateComplianceStatus: string = '/api/MasterManagement/UpdateComplianceStatus';
  static getCategoryForCompliance: string = '/api/MasterManagement/GetCategoryForCompliance';
  static getPolicyForCompliance: string = '/api/MasterManagement/GetPolicyForCompliance';
  
  
}

export class CurrentLoggedInUserApi {
  static getCurrentLoggedInUserRoleApiUrl: string = '/api/Account/GetUserRoleById';
  static getAssignedCompanyApiUrl: string = '/api/User/GetAssignedCompanyList';
  static getAssignedCompanyLoginTimeApiUrl: string = '/api/User/GetAssignedCompanyListAtLoginTime';
  static checkCompanySecurityCodeAvailableApiUrl: string = '/api/Account/CheckCompanySecurityCodeAvailable';
  static verifyCompanySecurityCodeApiUrl: string = '/api/Account/VerifyCompanySecurityCode';
  static setFavouriteCompanyApiUrl: string = '/api/User/SetFavouriteCompany';
  static getExpireSubscriptionOfLoggedInUserApiUrl: string = '/api/Account/GetExpireSubscriptionOfLoggedInUser';
}

export class DepartmentApi {
  static departmentList: string = '/api/Department/DepartmentList';
  static addOrEditDepartment: string = '/api/Department/AddEditDepartment';
  static deleteDepartment: string = '/api/Department/DeleteDepartment';
  static updateDepartmentStatus: string = '/api/Department/UpdateDepartmentStatus';
}

export class InfoSecApi {
  static apiPrefix: string = '/api/infosec/';
  static getProjectStatus: string = InfoSecApi.apiPrefix + 'GetProjectStatus';
  static getTimesheetStatus: string = InfoSecApi.apiPrefix + 'GetTimesheetStatus';
  static getApprover: string = InfoSecApi.apiPrefix + 'GetApprover';
  static saveProject: string = InfoSecApi.apiPrefix + 'SaveProject';
  static getProjectListApiUrl: string = InfoSecApi.apiPrefix + 'GetProjectListAsync';
  static getMyProjectListApiUrl: string = InfoSecApi.apiPrefix + 'GetMyProjectListAsync';
  static getProjectDetails: string = InfoSecApi.apiPrefix + 'GetProjectDetails';
  static updateProjectDetails: string = InfoSecApi.apiPrefix + 'UpdateProjectDetails';
  static getProjectResourceUsers: string = InfoSecApi.apiPrefix + 'GetProjectResourceUsers';
  static getProjectResourceListApiUrl: string = InfoSecApi.apiPrefix + 'GetProjectResourceListAsync';
  static getProjectDataApiUrl: string = InfoSecApi.apiPrefix + 'GetProjectData';
  static getAssignedResources: string = InfoSecApi.apiPrefix + 'GetAssignedResources';
  static saveProjectResourceTask: string = InfoSecApi.apiPrefix + 'SaveProjectResourceTask';
  static getProjectResourceTaskList: string = InfoSecApi.apiPrefix + 'GetProjectResourceTaskList';
  static getProjectResourceTaskOfUserList: string = InfoSecApi.apiPrefix + 'GetProjectResourceTaskOfUserList';
  static getAssignedResourcesOfTask: string = InfoSecApi.apiPrefix + 'GetAssignedResourcesOfTask';
  static getProjectTaskInformation: string = InfoSecApi.apiPrefix + 'GetProjectTaskInformationAsync';
  static deleteProjectResourceTask: string = InfoSecApi.apiPrefix + 'DeleteProjectResourceTask';
  static getReportTaskWiseResourceListApiUrl: string = InfoSecApi.apiPrefix + 'GetReportTaskWiseResourceListAsync';
  static getPDFReportTaskWiseResourceListApiUrl: string = InfoSecApi.apiPrefix + 'GetPDFReportTaskWiseResourceListAsync';
  static getExcelReportTaskWiseResourceListApiUrl: string = InfoSecApi.apiPrefix + 'GetExcelReportTaskWiseResourceListAsync';
  static getInfoSecDashboardAllUserDetails: string = InfoSecApi.apiPrefix + 'GetInfoSecDashboardAllUserDetails';
  static getInfoSecDashboardSystemAdminDetails: string = InfoSecApi.apiPrefix + 'GetInfoSecDashboardSystemAdminDetails';
  static getBsExpertResourceDetailsProjectWise: string = InfoSecApi.apiPrefix + 'GetBsExpertResourceDetailsProjectWise';
  static deleteProject: string = InfoSecApi.apiPrefix + 'DeleteProject';
  /*For Time sheet*/
  static getProjectDataForTimeSheetApiUrl: string = InfoSecApi.apiPrefix + 'GetProjectDataForTimeSheet';
  static getTaskByProjectIdApiUrl: string = InfoSecApi.apiPrefix + 'GetTaskByProjectId';
  static addEditTimeSheetApiUrl: string = InfoSecApi.apiPrefix + 'AddEditTimeSheet';
  static getTimeSheetByIdApiUrl: string = InfoSecApi.apiPrefix + 'GetTimeSheetById';
  static getTimeSheetListApiUrl: string = InfoSecApi.apiPrefix + 'GetTimeSheetList';
  static getProjectTimeSheetListApiUrl: string = InfoSecApi.apiPrefix + 'GetProjectTimeSheetList';
    static getTimeSheetStatusListApiUrl: string = InfoSecApi.apiPrefix + 'GetTimeSheetStatusList';
    static getTimeSheetApprovedStatusListApiUrl: string = InfoSecApi.apiPrefix + 'GetTimeSheetApprovedStatusList';
  static getResourcesListApiUrl: string = InfoSecApi.apiPrefix + 'GetResourceByProjectId';
  static getTaskByResourceIdApiUrl: string = InfoSecApi.apiPrefix + 'GetTaskByResourceId';

  static approveTimeSheetApiUrl: string = InfoSecApi.apiPrefix + 'ApproveTimeSheet';
  static getProjectHoursRequest: string = InfoSecApi.apiPrefix + 'GetProjectHoursRequest';
  static updateHoursRequestStatus: string = InfoSecApi.apiPrefix + 'UpdateHoursRequestStatus';
  static checkAllowedToCreateRequest: string = InfoSecApi.apiPrefix + 'CheckAllowedToCreateRequest';
  static getProjectHoursRequestFiles: string = InfoSecApi.apiPrefix + 'GetProjectHoursRequestFiles';
  static downloadFile: string = InfoSecApi.apiPrefix + 'DownloadFile';
  static downloadZipFile: string = InfoSecApi.apiPrefix + 'DownloadZipFile';


  static deleteProjectTimeSheetApiUrl: string = InfoSecApi.apiPrefix + 'DeleteProjectTimeSheet';
  /*End For Time sheet*/

  /*Project Report generation methods*/
  static getPDFReportProjectListApiUrl: string = InfoSecApi.apiPrefix + 'GetPDFReportProjectListAsync';
  static getExcelReportProjectListApiUrl: string = InfoSecApi.apiPrefix + 'GetExcelReportProjectListAsync';

  /*Project Report generation methods*/
  static getPDFReportProjectResourceListApiUrl: string = InfoSecApi.apiPrefix + 'GetPDFReportProjectResourceListAsync';
  static getExcelReportProjectResourceListApiUrl: string = InfoSecApi.apiPrefix + 'GetExcelReportProjectResourceListAsync';

  /*For Project Hours request*/
  static addHoursRequest: string = InfoSecApi.apiPrefix + 'AddHoursRequest';
  static uploadFiles: string = InfoSecApi.apiPrefix + 'UploadFiles';
  /*End For Project Hours request*/

  /*Start Email Api*/
  static projectHoursSendEmail: string = InfoSecApi.apiPrefix + 'ProjectHoursSendEmail';
  /*End Email Api*/



  static getProjectHoursHistoryListApiUrl: string = InfoSecApi.apiPrefix + 'GetProjectHoursHistoryListAsync';

}

export class MainTitleApi {
  static mainTitleListApiUrl: string = '/api/MasterManagement/MainTitleList';
  static addOrEditMainTitleApiUrl: string = '/api/MasterManagement/AddEditMainTitle';
  static deleteMainTitleApiUrl: string = '/api/MasterManagement/DeleteQuestionCategory';
  static updateMainTitleApiUrlStatus: string = '/api/MasterManagement/UpdateQuestionCategoryStatus';
}

export class MstServiceApi {
  static getMstServiceListApiUrl: string = '/api/MasterManagement/GetServiceList';
  static addOrEditMstServiceApiUrl: string = '/api/MasterManagement/AddEditService';
  static deleteServiceApiUrl: string = '/api/MasterManagement/DeleteService';
  static updateServiceStatusApiUrl: string = '/api/MasterManagement/UpdateServiceStatus';
}

export class ControlApi {
  
  static importControlFile: string = '/api/MasterManagement/ImportControlFile';
}


export class MyProfileApi {
  static changePasswordApiUrl: string = '/api/Account/ChangePassword';
  static editProfileApiUrl: string = '/api/Account/EditProfile';
  static getloggedInUserDetailApiUrl: string = '/api/Account/GetLoggedInUserDetail';
  static updateProfilePictureApiUrl: string = '/api/Account/UpdateProfilePicture';
  
}

export class PolicyApi {
  static getPolicyListApiUrl: string = '/api/MasterManagement/GetPolicyList';
  static addOrEditPolicyApiUrl: string = '/api/MasterManagement/AddEditPolicy';
  static getPolicyByIdApiUrl: string = '/api/MasterManagement/GetPolicyById';
  static getLastPolicyIdApiUrl: string = '/api/MasterManagement/GetLastPolicyId';
  static updatePolicyStatusApiUrl: string = '/api/MasterManagement/UpdatePolicyStatus';
  static updatePolicyDemoStatusApiUrl: string = '/api/MasterManagement/UpdatePolicyDemoStatus';
}

export class QuestionApi {
  static importQuestionApiUrl: string = '/api/Question/ImportQuestionnaire';

  static getCategoryDropDownApiUrl: string = '/api/Question/GetCategory';
  static getSubCategoryDropDownApiUrl: string = '/api/Question/GetSubCategoryByCategoryId';
  static getPolicyDropDownBySubCategory2IdApiUrl: string = '/api/Question/GetPolicyBySubCategory2Id';
  static getPolicyByPolicyIdApiUrl: string = '/api/Question/GetPolicyByPolicyId';
  static getQuestionnarieListApiUrl: string = '/api/Question/GetQuestionnarieList';

  static updateQuestionSetIsDemoApiUrl: string = '/api/Question/UpdateQuestionSetIsDemo';
  static updateQuestionIsApprovedApiUrl: string = '/api/Question/UpdateQuestionIsApproved';
  static updateQuestionIsReviewedApiUrl: string = '/api/Question/UpdateQuestionIsReviewed';

  static addOrEditQuestionApiUrl: string = '/api/Question/AddEditQuestion';
  static getQuestionSetDataApiUrl: string = '/api/Question/GetQuestionSetByPolicyId';

  static addQuestionSetApiUrl: string = '/api/Question/AddQuestionSet';
  static getPolicyDataApiUrl: string = '/api/Question/GetPolicyData';
  static getLastActiveQuestionNoApiUrl = '/api/Question/GetLastQuestionAndSubQuestionNo';
  static updatePolicyScoreApiUrl: string = '/api/Question/UpdatePolicyScore';
  static updatePolicyCommentApiUrl: string = '/api/Question/UpdatePolicyComment';
  static updatePolicyDescriptionApiUrl: string = '/api/Question/UpdatePolicyDescription';
  static updateRelatedPolicyApiUrl: string = '/api/Question/UpdateRelatedPolicy';

  /*Client Questionnarie urls*/
  static getPolicyDropDownByCompanyIdApiUrl: string = '/api/Question/GetPolicyByCompanyId';
  static getClientQuestionnarieListAsyncApiUrl: string = '/api/Question/GetClientQuestionnarieListAsync';
  /*End Client Questionnarie urls*/

}

export class QuestionCategoryApi {
  static questionCategoryList: string = '/api/MasterManagement/QuestionCategoryList';
  static addOrEditQuestionCategory: string = '/api/MasterManagement/AddEditQuestionCategory';
  static deleteQuestionCategory: string = '/api/MasterManagement/DeleteQuestionCategory';
  static updateQuestionCategoryStatus: string = '/api/MasterManagement/UpdateQuestionCategoryStatus';
}

/**Report Api Url**/
export class ReportApi {
  static apiPrefix: string = '/api/Report/';
  static getParentAssessmentByCompanyApiUrl = ReportApi.apiPrefix + 'GetParentAssessmentListByCompany';
  static riskReportAllCategoryApiUrl = ReportApi.apiPrefix + 'RiskReportAllCategory';
  static riskReportLineChartCategoryApiUrl = ReportApi.apiPrefix + 'RiskReportLineChartCategory';
  static maturityReportAllCategoryApiUrl = ReportApi.apiPrefix + 'MaturityReportAllCategory';
  static maturityReportLineChartCategoryApiUrl = ReportApi.apiPrefix + 'MaturityReportLineChartCategory';
  static remediationProgressReportApiUrl = ReportApi.apiPrefix + 'RemediationProgressReport';
  static comparisonRiskReportApiUrl = ReportApi.apiPrefix + 'ComparisonRiskReport';
  static comparisonMaturityReportApiUrl = ReportApi.apiPrefix + 'ComparisonMaturityReport';
  static getPdfForAllUserProjectWise = ReportApi.apiPrefix + 'GetPdfForAllUserProjectWise';
  static getPdfForBsExpertResourceUtilization = ReportApi.apiPrefix + 'getPdfForBsExpertResourceUtilization';
  static exportAssessmentReportChartApiUrl = ReportApi.apiPrefix + 'ExportAssessmentReportChartAsPdf';
  static riskListReportApiUrl = ReportApi.apiPrefix + 'RiskListReport';
  static riskIntegratorListReportApiUrl = ReportApi.apiPrefix + 'RiskIntegratorListReport';
  static exportRiskListReportApiUrl = ReportApi.apiPrefix + 'ExportRiskListReport';
  static getControlListApiUrl = ReportApi.apiPrefix + 'GetControlList';
  static getComplianceListApiUrl = ReportApi.apiPrefix + 'GetComplianceList';
  static getcatgeoryListFromSelectedControl = ReportApi.apiPrefix + 'getcatgeoryListFromSelectedControl';
  static getDocuemntFileApiUrl = ReportApi.apiPrefix + 'GetDownloadFile';
  static getSetControlList = ReportApi.apiPrefix + 'GetSetControlList';
  static riskReportCategoryByControlApiUrl = ReportApi.apiPrefix + 'RiskReportCategoryByControl';
  static maturityReportCategoryByControlApiUrl = ReportApi.apiPrefix + 'MaturityReportCategoryByControl';
  static getFirstAndSecondParentAssessmentCompaletedDateApiUrl = ReportApi.apiPrefix + 'getFirstAndSecondParentAssessmentCompaletedDate';
  static getEntityByParentAssessmentApiUrl = ReportApi.apiPrefix + 'GetEntityListByParentAssessment';
  static getEntityByCompanyApiUrl = ReportApi.apiPrefix + 'GetEntityListByCompany';
  static getParentAssessmentByEntityApiUrl = ReportApi.apiPrefix + 'GetParentAssessmentListByEntity';
}

export class RiskTreatmentApi {
  static initAddRiskTreatmentApiUrl: string = '/api/RiskTreatment/InitCreateRiskTreatment';
  static lastCompletedAssessmentByCategoryApiUrl: string = '/api/RiskTreatment/GetLastCompletedAssessmentByCategory';
  static addRiskTreatmentApiUrl: string = '/api/RiskTreatment/CreateRiskTreatment';
  static riskTreatmentListApiUrl: string = '/api/RiskTreatment/GetRiskTreatmentList';
  static getRiskTreatmentByIdApiUrl: string = '/api/RiskTreatment/GetRiskTreatmentById';
  static updateRiskTreatmentApiUrl: string = '/api/RiskTreatment/UpdateRiskTreatment';
  static deleteRiskTreatmentApiUrl: string = '/api/RiskTreatment/DeleteRiskTreatment';
  static riskTreatmentFillUpApiUrl: string = '/api/RiskTreatment/GetFillUpQuestion';
  static reviewQuestionApiUrl: string = '/api/RiskTreatment/GetReviewQuestion';
  static riskTreatmentCompletedPolicyApiUrl: string = '/api/RiskTreatment/GetRiskTreatmentCompletedPolicy';
  static riskTreatmentReviewBulkApiUrl: string = '/api/RiskTreatment/ReviewRiskTreatmentBulkCopy';
  static answerRiskTreatmentRedirectedQuestionApiUrl: string = '/api/RiskTreatment/AnswerRedirectedQuestion';
  static riskTreatmentFillUpQuestionByIdApiUrl: string = '/api/RiskTreatment/GetFillUpQuestionById';
  static riskTreatmentRedirectedQuestionListApiUrl: string = '/api/RiskTreatment/GetRedirectedQuestionList';
  static markAsCompletedApiUrl: string = '/api/RiskTreatment/MarkRiskTreatmentAsCompleted';
  static getEntityAndCategoryRiskTreatmentApiUrl: string = '/api/RiskTreatment/GetEntityAndCategoryRiskTreatment';
  static getCategoryFromEntityRiskTreatmentApiUrl: string = '/api/RiskTreatment/GetCategoryFromEntityRiskTreatment';
  static getDownloadFileApiUrl: string = '/api/RiskTreatment/GetDownloadFile';
}

export class RoleMangementApi {
  static getRoleManagementpiUrl: string = '/api/RoleManagement/GetRoleManagement';
  static saveRoleManagementpiUrl: string = '/api/RoleManagement/SaveRoleManagement';
  static GetPermissionForLoggedInUser: string = '/api/RoleManagement/GetPermissionForLoggedInUser';
}

export class SubscriptionApi {
  static addOrEditSubscriptionApiUrl: string = '/api/Subscription/AddEditSubscription';
  static getSubscriptionListApiUrl: string = '/api/Subscription/GetSubscriptionList';
  static getServicesDataApiUrl: string = '/api/Subscription/GetServicesData';
  static updateSubscriptionStatus: string = '/api/Subscription/UpdateSubscriptionStatus';
  static getSubscriptionById: string = '/api/Subscription/GetSubscriptionById';

  static addManageSubscriptionApiUrl: string = '/api/Subscription/AddManageSubscription';
  static editManageSubscriptionApiUrl: string = '/api/Subscription/EditManageSubscription';


  static getSetupMasterSubscriptionData: string = '/api/Subscription/GetSetupMasterSubscriptionData';

  static getServiceDataBySubscriptionIdApiUrl: string = '/api/Subscription/GetServiceDataBySubscriptionId';
  static deleteSubscriptionApiUrl: string = '/api/Subscription/DeleteSubscription';
}

export class SubTitleApi {
  static subTitleListApiUrl: string = '/api/MasterManagement/SubTitleList';
  static addOrEditSubTitleApiUrl: string = '/api/MasterManagement/AddEditSubTitle';
}

export class UserApi {
  static userList: string = '/api/Account/UserList';
  static roleList: string = '/api/Account/RoleList';
  static clientAdminList: string = '/api/Account/GetClientAdminList';
  static updateUserStatus: string = '/api/Account/UpdateUserStatus';
  static addUser: string = '/api/Account/AddUserAsync';
  static editUser: string = '/api/Account/EditUserProfile';
  static approveSystemAdminApiUrl: string = '/api/Account/ApproveSystemAdmin';
  static departmentList: string = '/api/Account/DepartmentList';
  static initAssignCompanytoUser: string = '/api/User/InitAssignCompanyToUser';
  static updateAssignedCompanyToUserApiUrl: string = '/api/User/UpdateAssignedCompanyToUser';
  static enabledOrDisableSecurityCodeApiUrl: string = '/api/User/EnabledOrDisableSecurityCode';
  static recoverDeletedUserApiUrl: string = '/api/Account/RecoverDeletedUser';
}

export class CompanyPolicyDocumentApi {
  static companyPolicyDocumentListApiUrl: string = '/api/MasterManagement/GetCompanyPolicyDocumentList';
  static companyPolicyDocumentAddApiUrl: string = '/api/MasterManagement/AddCompanyPolicyDocumentFile';
  static downloadCompanyPolicyDocumentApiUrl: string = '/api/MasterManagement/DownloadCompanyPolicyDocument';
  static viewCompanyPolicyDocumentFileApiUrl: string = '/api/MasterManagement/ViewCompanyPolicyDocument';
  static deleteCompanyPolicyDocumentApiUrl = '/api/MasterManagement/DeleteCompanyPolicyDocument';
}

export class ProcedureDocumentApi {
  static procedureDocumentListApiUrl: string = '/api/MasterManagement/GetProcedureDocumentList';
  static procedureDocumentAddApiUrl: string = '/api/MasterManagement/AddProcedureDocumentFile';
  static downloadProcedureDocumentApiUrl: string = '/api/MasterManagement/DownloadProcedureDocument';
  static deleteProcedureDocumentApiUrl = '/api/MasterManagement/DeleteProcedureDocument';
}

export class CommonResponseAPI {
  static commonMessage: string = '/api/common/messages';
}

export class PaymentAPI {
  static getOtpForPayment: string = '/api/Account/GetOtpForPayment';

  static verifyOtpForPayment: string = '/api/Account/VerifyOtpForPayment';
  static processPayment: string = '/api/Payment/process';
  static processPaypalPayment: string = '/api/Payment/processPaypal';
  static confirm: string = '/api/Payment/confirm';
static GetUserSubscriptionDetailsWithPagesProfile: string = '/api/Payment/GetUserSubscriptionDetailsWithPagesProfile';
    static GetUserSubscriptionDetailsWithPages: string = '/api/Payment/GetUserSubscriptionDetailsWithPages';
    static CancleSubsciption: string = '/api/Payment/cancelSubscription';
    static GetUserSubscriptionDetailsWithPagesPlan: string = '/api/Payment/GetUserSubscriptionDetailsWithPagesPlan';
  static getAllActivePlans: string = '/api/Payment/GetAllActivePlans';
  static getCouponByName: string = '/api/Payment/GetCouponByName';
  static getAllCoupons: string = '/api/Payment/GetAllCoupons';
  static getUserSubscriptionDetailsWithPages: string = '/api/Payment/GetUserSubscriptionDetailsWithPages';
  
}
